import { Link } from "react-router-dom";

const Submit = () => (
  <div className="space-y-6">
    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary">Submission</p>
    <h1 className="text-4xl text-slate-100">Submit a guild or community</h1>
    <p className="text-lg text-slate-300">
      The full form will be embedded here once your workflow is ready. For now, review the requirements and email us so we can schedule a short verification call.
    </p>

    <section className="panel space-y-4 text-sm text-slate-300">
      <div>
        <p className="text-slate-100">Requirements</p>
        <ul className="mt-2 list-disc space-y-2 pl-6 text-slate-400">
          <li>Community must be active within the last 30 days.</li>
          <li>Clear point of contact and transparent code of conduct.</li>
          <li>Location data for the map (city + coordinates).</li>
          <li>Platform links that can be shared publicly.</li>
        </ul>
      </div>
      <div className="rounded-2xl border border-dashed border-brand-ink/50 bg-brand-night/80 p-6 text-center text-slate-500">
        <p>Embed form placeholder</p>
        <p className="text-xs uppercase tracking-[0.3em]">Coming soon</p>
      </div>
      <p>
        Need help? Email <a className="text-brand-primary" href="mailto:hello@memberdiscovery.com">hello@memberdiscovery.com</a> or use the <Link to="/about" className="text-brand-primary">about page</Link> to learn how we review submissions.
      </p>
    </section>
  </div>
);

export default Submit;
